export default function initTableauPrestation(): void {
    const $tableauPrestationContainer = document.querySelectorAll<HTMLElement>('.js-exposant-prestation');
    $tableauPrestationContainer.forEach($container => {
        new TableauPrestation($container);
    });
}

class TableauPrestation {
    $el: HTMLElement | null;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        if (this.$el) {
            this.init();

            this.updateTotalCat();
            this.updateTotalGeneral()
        }
    }

    init(): void {
        const services = this.$el?.querySelectorAll<HTMLElement>('.js-service');

        if (services) {
            services.forEach(service => {
                const price = parseInt(service.dataset.priceService || '0', 10) ?? 0;
                const nbItemInput = service.querySelector<HTMLInputElement>('.js-nb-item-input');
                const nbItem = service.querySelector<HTMLElement>('.js-nb-item');
                const totalServiceInput = service.querySelector<HTMLInputElement>('.js-total-service-input');
                const totalService = service.querySelector<HTMLElement>('.js-total-service');
                const minusBtn = service.querySelector<HTMLButtonElement>('.js-nb-item-minus');
                const plusBtn = service.querySelector<HTMLButtonElement>('.js-nb-item-plus');

                if (nbItem && nbItemInput && totalServiceInput && totalService && minusBtn && plusBtn) {
                    minusBtn.addEventListener('click', () => this.handleOperation('decrement', nbItem, nbItemInput, totalService, totalServiceInput, price));
                    plusBtn.addEventListener('click', () => this.handleOperation('increment', nbItem, nbItemInput, totalService, totalServiceInput, price));
                }

                if (totalService && totalServiceInput && nbItemInput && parseInt(nbItemInput.value, 10) > 0) {
                    totalServiceInput.value = (parseInt(nbItemInput.value, 10) * price).toString();
                    totalService.innerHTML = (parseInt(nbItemInput.value, 10) * price).toString();
                }
            });
        }
    }

    handleOperation(
        operation: 'increment' | 'decrement',
        nbItem: HTMLElement,
        nbItemInput: HTMLInputElement,
        totalService: HTMLElement,
        totalServiceInput: HTMLInputElement,
        price: number,
    ): void {
        let nbItemValue = parseInt(nbItemInput.value, 10);
    
        if (operation === 'increment') {
            nbItemValue++;
        } else if (operation === 'decrement') {
            nbItemValue = nbItemValue <= 0 ? 0 : nbItemValue - 1;
        }
        
        const event = new Event('change');
        nbItemInput.dispatchEvent(event);

        nbItemInput.value = nbItemValue.toString();
        nbItem.innerHTML = nbItemValue.toString();
        totalServiceInput.value = (nbItemValue * price).toString();
        totalService.innerHTML = (nbItemValue * price).toString();
    
        this.updateTotalGeneral();
        this.updateTotalCat();
    }

    updateTotalCat(): void {
        const exposantPrestationCats = this.$el?.querySelectorAll<HTMLElement>('.js-exposant-prestation-cat');
        if (exposantPrestationCats) {
            exposantPrestationCats.forEach(cat => {
                const totalCat = cat.querySelector<HTMLElement>('.js-total-cat');
                const services = cat.querySelectorAll<HTMLElement>('.js-service');
                let totalCatValue = 0;

                if (services) {
                    services.forEach(service => {
                        const totalServiceInput = service.querySelector<HTMLInputElement>('.js-total-service-input');
                        if (totalServiceInput) {
                            totalCatValue += parseInt(totalServiceInput.value, 10);
                        }
                    });
                }

                if (totalCat) {
                    totalCat.innerHTML = totalCatValue.toString();
                    const totalCatWrapper = cat.querySelector<HTMLElement>('.js-total-cat-wrapper');
                    if (totalCatValue > 0 && totalCatWrapper) {
                        totalCatWrapper.classList.remove('hidden');
                    } else if (totalCatWrapper) {
                        totalCatWrapper.classList.add('hidden');
                    }
                }
            });
        }
    }

    updateTotalGeneral(): void {
        const services = this.$el?.querySelectorAll<HTMLElement>('.js-service');
        let totalPrestationValue = 0;

        if (services) {
            services.forEach(service => {
                const totalServiceInput = service.querySelector<HTMLInputElement>('.js-total-service-input');
                if (totalServiceInput) {
                    totalPrestationValue += parseInt(totalServiceInput.value, 10);
                }
            });
        }

        const totalPrestationInput = this.$el?.querySelector<HTMLInputElement>('.js-total-prestation-input');
        const totalPrestation = this.$el?.querySelector<HTMLInputElement>('.js-total-prestation');
        const totalPrestationTTC = this.$el?.querySelector<HTMLInputElement>('.js-total-prestation-ttc');
        if (totalPrestationInput && totalPrestation) {
            totalPrestationInput.value = totalPrestationValue.toString();
            totalPrestation.innerHTML = totalPrestationValue.toString();
            if (totalPrestationTTC) {
                totalPrestationTTC.innerHTML = this.htToTtc(totalPrestationValue, 20, 2);
            }
            
        }
    }

    htToTtc(amount_ht: number, tva: number, decimals: number): string {
        let amount_ttc: number = amount_ht * (1 + (tva / 100));
        return amount_ttc % 1 === 0 ? this.formatWithComma(amount_ttc, 0) : this.formatWithComma(amount_ttc, decimals);
    }

    formatWithComma(value: number, decimals: number): string {
        return value.toLocaleString('fr-FR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }
}
